import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ResourceService } from '@teem/generic/resource.service';
import { Customer, CustomerSerializer } from '@teem/models/customer';
import { customer as CustomerApi } from '@teem/constants/api';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class ProfileService extends ResourceService<Customer> {

  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      CustomerApi.endPoint,
      new CustomerSerializer()
    )
  }

  public getInfo() {
    return this.httpClient.get(`${CustomerApi.getInfo}`);
  }

  public signin(params: any) {
    return this.httpClient.post(`${CustomerApi.login}`, params);
  }

  public singup(params: any) {
    return this.httpClient.post(`${CustomerApi.signup}`, params);
  }

  public updateInfo(params: any) {
    return this.httpClient.post(`${CustomerApi.update}`, params);
  }

  public addAddress(params: any) {
    return this.httpClient.post(`${CustomerApi.addAddress}`, params);
  }


  public updatePassword(params: any) {
    return this.httpClient.post(`${CustomerApi.updatePassword}`, params);
  }

  public logout(params: any) {
    return this.httpClient.post(`${CustomerApi.logout}`, params);
  }

  public getOrders() {
    return this.httpClient.get(`${CustomerApi.orders}`);
  }

  public getCities(regionId: string) {
    if (regionId)
      return this.httpClient.get(`${CustomerApi.cities}?region_id=${regionId}`)
    else
      return this.httpClient.get(`${CustomerApi.cities}?limit=100`)
  }

  public getDistricts(cityId: string) {
    if (cityId)
      return this.httpClient.get(`${CustomerApi.districts}?city_id=${cityId}`)
    else
      return this.httpClient.get(`${CustomerApi.districts}?limit=100`)
  }

  public deleteAddress(params: any) {
    return this.httpClient.post(`${CustomerApi.deleteAddress}`, params);
  }

  public verifyLogin(params: any) {
    return this.httpClient.post(`${CustomerApi.verifyLogin}`, params);
  }

  public resendOtp(params: any) {
    return this.httpClient.post(`${CustomerApi.resend}`, params);
  }

  public sendOtp(params: any) {
    return this.httpClient.post(`${CustomerApi.send}`, params);
  }

  public verifyOtp(params: any) {
    return this.httpClient.post(`${CustomerApi.verify}`, params);
  }

  checkEmail(email: any): Observable<any> {
    return this.httpClient.post<{ exists: boolean }>(`${CustomerApi.checkEmail}`, { email });
  }

  checkPhone(phone: any): Observable<any> {
    return this.httpClient.post<{ exists: boolean }>(`${CustomerApi.checkPhone}`, { phone });
  }

  public sendForgotOtp(params: any) {
      return this.httpClient.post(`${CustomerApi.sendForgotOtp}`, params);
  }

  public verifyForgot(params: any) {
      return this.httpClient.post(`${CustomerApi.verifyForgot}`, params);
  }

  public setPassword(params: any) {
      return this.httpClient.post(`${CustomerApi.setPassword}`, params);
  }
}